import { RefObject, useEffect, useState, useRef } from 'react';

export type ElementSizeProps = {
    width: number;
    height: number;
};

export default function useElementResizeObserver(tabContainerRef: RefObject<HTMLElement>): ElementSizeProps {
    const [elementSize, setElementSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    const resizingDelayTimer = useRef(null);

    useEffect(() => {
        const resizeObserver = new ResizeObserver(() => {
            clearTimeout(resizingDelayTimer.current);
            resizingDelayTimer.current = setTimeout(() => {
                if (tabContainerRef.current) {
                    const width = tabContainerRef.current.clientWidth;
                    const height = tabContainerRef.current.clientHeight;
                    setElementSize({
                        width,
                        height,
                    });
                }
            }, 10);
        });

        if (tabContainerRef.current) {
            resizeObserver.observe(tabContainerRef.current);
        }

        return (): void => {
            resizeObserver.disconnect();
        };
    }, [tabContainerRef]);

    return elementSize;
}
